import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { WjGridModule } from '@grapecity/wijmo.angular2legacy.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2legacy.grid.filter';
import { WjInputModule } from '@grapecity/wijmo.angular2legacy.input';
import { WjNavModule, WjTreeView } from '@grapecity/wijmo.angular2legacy.nav';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { AuthenticationService } from './service/authentication.service';
import { UtilityService } from './service/utility.service';
import { AlertService } from './service/alert.service';
import { AclGuard } from './guard/acl.guard';

import { AlertComponent } from './alert/alert.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { ModalConfirmComponent } from './modal-confirm/modal-confirm.component';
import { ModalWaitComponent } from './modal-wait/modal-wait.component';
import { PreviewComponent } from './preview/preview.component';
import { GolfListComponent } from './golf-list/golf-list.component';
import { GolfModComponent } from './golf-mod/golf-mod.component';

import * as wjcCore from '@grapecity/wijmo';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AttendanceListComponent } from './attendance-list/attendance-list.component';
import { AttendanceDetailComponent } from './attendance-detail/attendance-detail.component';
import { RequestListComponent } from './request-list/request-list.component';
import { ListFilterPipe } from './list-filter.pipe';
import { GolfworkModComponent } from './golfwork-mod/golfwork-mod.component';
import { RequestViewComponent } from './request-view/request-view.component';
import { RequestModComponent } from './request-mod/request-mod.component';
import { EmployeeListComponent } from './employee-list/employee-list.component';
import { EmployeeModComponent } from './employee-mod/employee-mod.component';
import { AttendanceViewComponent } from './attendance-view/attendance-view.component';
import { AttendanceModComponent } from './attendance-mod/attendance-mod.component';
import { PasschgComponent } from './passchg/passchg.component';
import { EmployeeSelectComponent } from './employee-select/employee-select.component';
import { UserService } from './service/user.service';
import { MemoModComponent } from './memo-mod/memo-mod.component';
import { GolfEmployeeListComponent } from './golf-employee-list/golf-employee-list.component';
// ライセンス設定
wjcCore.setLicenseKey('staff.tmpsys.com|system.g1japan.com|system.g1japan.jp|systest.g1japan.com|pre.g1japan.jp|pre.g1japan.com|localhost,135569852559855#B0UW1qgauI0ISYONkIsISN5gTO5UjM5gTO6UTNzEjI0ICZJJCL355W0IyZsZmIsIiM6RjMwIjI0IiclZnIsU6csFmZ0IiczRmI1pjIs9WQisnOiQkIsISP3cneQp5K6RWYp5GdDhFTDBTQ8dGO6RndXlkY4gnVrhmR8h4Q7BTVrxkcHFWbMNUV9pmVBZFRNNETJ9GbSJmSwBXRpFDZXV7cBdlM5YzUlJEMz54MxATZ7ckZXdGUzR7VP5UczkVVLF5S6k4VppFapF5LJxUYph5aV5mSyY7MKBTcxUVMjlFUuRFVwNzQlpmSVRFOCpHZzAVNSp4ZSNXOMN4KuZVOzIlZG5GTZtyQxQ6U49mWjpVM6V5cmJFauNUapdFOy8maFFFMU3WaPJzavNUYWp5LzpUeBBVcNlWMBNVVXF6RTZUVRdnU6EmR7tSMjZlRVllVBNFW0dmW5lWW5MlUMl5Qk94T5NnVqZkQ7lUctd4ZzY7YOZFdaBnWTZGWQJXQwlTUR96czJWM9xGeyRUcykkaOl5Vx84RNNHMONDShJFOMV5RwYkWppnTBdFbUd4Kh94bhJiOiMlIsIiR9cTRGJUOiojIIJCL7ITMwkDM7IDO0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsIyM5IjM7ADI5ITMxQjMwIjI0ICdyNkIsICdz3GasF6YvxGLt36Yu8WYwFmaxcmLlJHcsAnau8WYwFmaxcmLlJHcs46bj9ibhBXYqFzZuQ7clR7c9NHLwpmLuFGchpWMn9SblR7c9NHLt36Yu8WYwFmaxcmLtVGdzl7cs46bj9yc9NHctRnLmZWY4NnI0IyctRkIsIiuCOOoDOuhDOeuCO+tCOulDO+oCOuhDO+rCOeqDOOiDOuoCOuvkeum+S1j');

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AlertComponent,
    ModalConfirmComponent,
    LogoutComponent,
    GolfListComponent,
    GolfModComponent,
    AttendanceListComponent,
    AttendanceDetailComponent,
    RequestListComponent,
    ListFilterPipe,
    GolfworkModComponent,
    RequestViewComponent,
    RequestModComponent,
    EmployeeListComponent,
    EmployeeModComponent,
    AttendanceViewComponent,
    AttendanceModComponent,
    PasschgComponent,
    EmployeeSelectComponent,
    MemoModComponent,
    GolfEmployeeListComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    HttpClientModule,
    WjGridModule,
    WjGridFilterModule,
    WjNavModule,
    WjInputModule,
    NgbModule,
    DragDropModule,
    AppRoutingModule,
    BrowserAnimationsModule
  ],
  providers: [
    AclGuard,
    AuthenticationService,
    UserService,
    UtilityService,
    AlertService,
    // ng build --output-path=./dist/shift --base-href=/shift/ --output-hashing=all
    // ng build --output-hashing=all
    // {provide: 'ApiUrl', useValue: 'http://localhost:8080/'},
    // {provide: 'ApiUrl', useValue: 'https://pre.g1japan.jp/'},
    {provide: 'ApiUrl', useValue: 'https://staff.tmpsys.com/'},
    // {provide: 'ApiUrl', useValue: 'https://pre.g1japan.com/'},
  ],
  entryComponents: [ModalConfirmComponent, ModalWaitComponent, PreviewComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
